"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var images = {};

var imageCheck = function imageCheck(url) {
    var cache = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

    return new Promise(function (resolve, reject) {
        if (images[url]) return resolve(images[url]);

        var image = new Image();
        image.src = url;
        image.onload = function () {
            var data = { url: url, width: image.width, height: image.height };
            if (cache) images[url] = data;
            return resolve(data);
        };
        image.onerror = function (err) {
            return reject(err);
        };
    });
};

exports["default"] = imageCheck;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/image-check/dist/index.js
// module id = 30
// module chunks = 0